import './checkboxes-values';

(function($) {
    /* TODO: Fix this, one constant for different row types */
    var TYPE_DEPENDENT = 3; 

    $.widget('ca.caAdditionalCharges', $.ca.caCheckboxesValues, {
        _create : function() {
            this.options.table_name = this.element.attr('id');            
            this.setChangeable(true);
            this.rows = [];     
            this.options.showPlaceholders = false;
            this.colHoldValue = [];
            this.chargeCount = 1;
            this.defaultValues = {};
            this.billingGroup = {
                amount_type: null,
                amount: 0
            };
            this.billedCols = {};
            this.options.allowFeeProration = false;
            
            this.element.on('keyup', 'input[type=text]', function(){
                if ($(this).closest('td').hasClass('col-type-number')) {
                    this.value = this.value.replace(/[^0-9\.]/g, '');
                }
            });
        },

        createTable: function(readonly) {
            readonly = (readonly === true);
            this.options.removableRows = !readonly;

            var rows = [];
            if (this.options.values && this.options.values[TYPE_DEPENDENT]) {
                $.each(this.options.values[TYPE_DEPENDENT], function(){
                    rows.push({
                        title: 'Charge',
                        type: TYPE_DEPENDENT
                    }); 
                });
            } else {
                rows.push({
                    title: 'Charge',
                    type: TYPE_DEPENDENT
                }); 
            }

            this.rows = rows;
            this.values = this.applyValues(this.options.columns, this.options.values);

            this.buildTables();

            if (readonly) {
                this.element.find('.col-type-autocomplete').find('input.ui-autocomplete-input').caAutocomplete('setChangeable', false);
                this.element.find('.col-type-dropdown select').prop('disabled', true);
            }
        
            var self = this;
            self.setValues(self.values);
            setTimeout(
                function(){
                    if (readonly) {
                        self.element.find('.col-type-text input').prop('readonly', true);
                    }
                },
                500
            );
            
            this.element.data('initialized', true);
        },

        onChangeEntity: function(dropdown)
        {
            var dropdownControl = $(dropdown);
            var lastValue = dropdownControl.data('lastValue');
            var entityId = dropdownControl.val();
            var autocomplete = dropdownControl.parents('tr')
                .find('.col-type-autocomplete')
                .find('input.ui-autocomplete-input');
            autocomplete.caAutocomplete('option', 'data.entity_id', entityId);

            if (autocomplete.length > 0) {
                if (!isNaN(lastValue) && lastValue > 0) {
                    this.saveAccGroup(autocomplete, lastValue);
                }

                autocomplete.caAutocomplete('clearItem');
                this.restoreAccGroup(autocomplete, entityId);
            }
        },

        getAccGroupInputName: function(autocomplete, entityId)
        {
            return autocomplete.caAutocomplete('option', 'fieldName')
                .replace(/\[(\w+)\]+$/, '[acc_group_' + entityId + ']');
        },

        restoreAccGroup: function(autocomplete, entityId)
        {
            var accGroupInputName = this.getAccGroupInputName(autocomplete, entityId);
            var entityAccGroup = $("input[name='" + accGroupInputName + "']");
            if (entityAccGroup.length > 0 && entityAccGroup.val() > 0) {
                var accGroup = {
                    id: entityAccGroup.val(),
                    label: entityAccGroup.data('label')
                };

                autocomplete.caAutocomplete('setItem', accGroup);
            }

            autocomplete.caAutocomplete('option', 'data.entity_id', entityId);
        },

        addAccGroupInput: function(autocomplete, entityId, accGroupId, accGroupLabel)
        {
            var accGroupInputName = this.getAccGroupInputName(autocomplete, entityId);

            var label = $("<input/>").attr('type', 'hidden')
                .attr('name', accGroupInputName)
                .val(accGroupId)
                .data('label', accGroupLabel);

            autocomplete.closest('.col-type-autocomplete')
                .append(label);
        },

        saveAccGroup: function(autocomplete, entityId)
        {
            var item = autocomplete.caAutocomplete('getItem');
            var accGroupInputName = this.getAccGroupInputName(autocomplete, entityId);
            var entityAccGroup = $("input[name='" + accGroupInputName + "']");

            if (item) {
                if (entityAccGroup.length > 0) {
                    entityAccGroup.val(item.id)
                        .data('label', item.label);
                } else {
                    this.addAccGroupInput(autocomplete, entityId, item.id, item.label);
                }
            } else {
                entityAccGroup.remove();
            }
        },

        setAutocompleteValue: function(td, row, field)
        {
            if (this.options.autocomplete && this.options.autocomplete[row + 1]) {
                var self = this;
                var autocomplete = td.find('input.ui-autocomplete-input');

                autocomplete.parent().on('click', 'a', function () {
                    var entity = autocomplete.caAutocomplete('option', 'data.entity_id');
                    var accGroupInputName = self.getAccGroupInputName(autocomplete, entity);
                    var entityAccGroup = $("input[name='" + accGroupInputName + "']");
                    entityAccGroup.remove();
                });

                var options = this.options.autocomplete[row + 1];

                if (field.value) {
                    $.each(field.value, function (entityId, accGroupId) {
                        if (options[accGroupId]) {
                            var item = {
                                id: accGroupId,
                                label: options[accGroupId].label
                            };

                            if (options[accGroupId].isDefault) {
                                autocomplete.caAutocomplete('setItem', item);
                                autocomplete.caAutocomplete('option', 'data.entity_id', entityId);
                            }

                            self.addAccGroupInput(autocomplete, entityId, item.id, item.label);
                        } else {
                            autocomplete.caAutocomplete('option', 'data.entity_id', entityId);
                        }
                    });
                }
            }
        },

        getAutocompleteValue: function($td)
        {
            var value = {};
            $td.find('>input[type=hidden]').each(function(){
                var nameData = this.name.match(/\[acc_group_(\d)\]$/);
                if (nameData && nameData[1] != null) {
                    var entityId = nameData[1];
                    var accGroupId = this.value;
                    value[entityId] = accGroupId;
                }                
            });
            return value;
        },

        onAutocompleteChange: function(event, ui)
        {
            var autocomplete = $(event.target).parent().find('input.ui-autocomplete-input');
            var entityId = autocomplete.caAutocomplete('option', 'data.entity_id');
            this.saveAccGroup(autocomplete, entityId);
        }
    });
})(jQuery);